import React, { useEffect } from "react";
import CardInput from "../../components/CardInput";
import { callAPI } from "../../utils";
import { getCreateCreditTokenUrl } from "../shared/createCreditToken.utils";
import {
  buildGenericRequest,
  getGenericActionRedirectUrl,
  getGenericSuccessUrl,
} from "./Generic.utils";

const getErrorMessage = (error) =>
  error?.response?.data?.response?.message ??
  error?.response?.data?.message ??
  error?.message ??
  "Unable to add card.";

export default function Generic(props) {
  const { alert, setIsLoading, onSuccess, onFailure } = props;
  const actionRedirectUrl = getGenericActionRedirectUrl(props);

  useEffect(() => {
    if (!actionRedirectUrl) {
      return;
    }
    setIsLoading?.(true);
    window.location.assign(actionRedirectUrl);
  }, [actionRedirectUrl, setIsLoading]);

  const onSubmit = async (formData) => {
    setIsLoading(true);
    try {
      const response = await callAPI(
        getCreateCreditTokenUrl(
          process.env.REACT_APP_WEBHOOK_API_ENDPOINT,
          props.userType ?? props.t
        ),
        "POST",
        buildGenericRequest(formData, props)
      );
      if (response?.returnCode !== 200) {
        throw new Error(
          response?.response?.message ??
            `Add card error: ${response?.returnCode ?? "unknown"}`
        );
      }

      onSuccess?.(response);
      const successUrl = getGenericSuccessUrl(props);
      if (!successUrl) {
        throw new Error("Success redirect URL is missing.");
      }
      window.location.assign(successUrl);
    } catch (error) {
      const message = getErrorMessage(error);
      alert(message);
      onFailure?.(message);
    } finally {
      setIsLoading(false);
    }
  };

  if (actionRedirectUrl) {
    return null;
  }

  return (
    <div>
      <CardInput onSubmit={onSubmit} configGateway={props} />
    </div>
  );
}
